import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProductScreenshot = makeShortcode("ProductScreenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You can sync data from Google Ads reports by configuring it as a source in PostHog. The supported reports that can be synced include Ad, AdStats, AdGroup, AdGroupStats, Campaign, CampaignStats, Keyword, KeywordStats, Video, and VideoStats, as they are described in the `}<a parentName="p" {...{
        "href": "https://cloud.google.com/bigquery/docs/google-ads-transformation"
      }}>{`Google Ads BigQuery transformation documentation`}</a>{`. Additional reports will be added based on user feedback we receive via our `}<a parentName="p" {...{
        "href": "https://app.posthog.com/#panel=support%3Afeedback%3Adata_warehouse%3Alow%3Atrue"
      }}>{`in-app support form`}</a>{`.`}</p>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "https://support.google.com/google-ads/answer/1704344"
        }}>{`Google Ads customer ID`}</a>{` of the account you are trying to sync to PostHog.`}</li>
      <li parentName="ul">{`Administrator access to the Google Ads account you want to sync. If you use manager accounts then this is often enough to connect. An manager account is an Ads account type that enables you to manage several Ads accounts under a single login – `}<a parentName="li" {...{
          "href": "https://support.google.com/google-ads/answer/6139186"
        }}>{`see here for more on Google Ads manager accounts`}</a>{`.`}</li>
      <li parentName="ul">{`During the authentication, make sure you check the necessary scopes.`}</li>
    </ul>
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/w_500,c_limit,q_auto,f_auto/Screenshot_2025_10_02_at_1_46_13_PM_fda20371c8.png" classes="rounded" alt="Accept scope checkbox" mdxType="ProductScreenshot" />
    <ProductScreenshot imageLight="https://res.cloudinary.com/dmukukwp6/image/upload/2024_10_31_at_15_15_51_a7a003008c.png" classes="rounded" alt="Location of the Google Ads Customer ID" mdxType="ProductScreenshot" />
    <h2 {...{
      "id": "configuring-posthog"
    }}>{`Configuring PostHog`}</h2>
    <p>{`Connect PostHog to your Google Ads account using a Google account. The Google account must have administrator access to your Google Ads account.`}</p>
    <ol>
      <li parentName="ol">{`In PostHog, go to the `}<strong parentName="li"><a parentName="strong" {...{
            "href": "https://app.posthog.com/pipeline/sources"
          }}>{`Data pipelines`}</a></strong>{` tab.`}</li>
      <li parentName="ol">{`Open the `}<strong parentName="li">{`+ New`}</strong>{` drop-down menu in the top-right and select `}<strong parentName="li">{`Source`}</strong>{`.`}</li>
      <li parentName="ol">{`Find Google Ads in the sources list and click `}<strong parentName="li">{`Link`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter the `}<strong parentName="li">{`Google Ads customer ID`}</strong>{` of the Google Ads account you want to sync.`}</li>
      <li parentName="ol">{`Select an existing Google Ads account, or create a new integration`}</li>
      <li parentName="ol">{`(Optional) Add a prefix for the table name.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      